<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.83,3.7000013411717116C15.83,3.7000013411717116,12.77,6.7500013411717115,12.77,6.7500013411717115C12.77,6.7500013411717115,9.93,6.050001341171711,9.93,6.050001341171711C9.93,6.050001341171711,9.23,3.2200013411717117,9.23,3.2200013411717117C9.23,3.2200013411717117,12.29,0.16999934117171167,12.29,0.16999934117171167C10.62,-0.27000065882828833,8.77,0.14999934117171168,7.46,1.4600013411717117C6,2.9100013411717116,5.63,5.030001341171712,6.34,6.820001341171712C6.34,6.820001341171712,0.58,12.579961341171712,0.58,12.579961341171712C0.22,12.939961341171712,0,13.439961341171712,0,13.989961341171712C0,15.089961341171712,0.9,15.989961341171712,2,15.989961341171712C2.55,15.989961341171712,3.05,15.769961341171712,3.41,15.399961341171712C3.41,15.399961341171712,3.41,15.399961341171712,3.41,15.399961341171712C3.41,15.399961341171712,9.18,9.630001341171711,9.18,9.630001341171711C10.97,10.319961341171712,13.09,9.960001341171711,14.53,8.510001341171712C15.85,7.210001341171711,16.27,5.360001341171712,15.83,3.7000013411717116C15.83,3.7000013411717116,15.83,3.7000013411717116,15.83,3.7000013411717116Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Wrench',
} as DefineComponent
</script>
